import React, { ReactNode } from 'react';
import { OverlayTrigger, Tooltip as BsTooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/pro-regular-svg-icons';

interface Props {
	children: ReactNode;
	id: string;
}

const Tooltip = ({ children, id }: Props) => (
	<OverlayTrigger
		placement='top'
		overlay={<BsTooltip id={`help-${id}`}>{children}</BsTooltip>}
		trigger={['hover', 'focus', 'click']}
	>
		<span
			tabIndex={0}
			role='img'
			aria-label='Help'
			className='tooltip-icon ms-1'
		>
			<FontAwesomeIcon icon={faCircleQuestion} />
		</span>
	</OverlayTrigger>
);

export default Tooltip;
